<template>
	<button
		type="button"
		class="text-mx-gray-400"
		@click.prevent="toggle"
	>
		<IconSlashedEye v-if="showPassword" />
		<IconEye v-else />
	</button>
</template>

<script setup lang="ts">
const showPassword = defineModel({
	type: Boolean,
	default: true
})

const toggle = () => {
	showPassword.value = !showPassword.value
}
</script>
